module.exports = __webpack_public_path__ + "static/media/icon-plus.83f81ca8.webp";